/** @jsxImportSource theme-ui */
import * as React from "react";
// DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using iconTemplate.js Please refer to web/src/nessie/icons/README.md for more details
import { nessiePropCheckerWrapper } from "../../nessiePropCheckerWrapper";
import {
  NessieFunctionComponent,
  NessieComponentProps,
  colorNessieResponsivePropType,
  oneOfNessieResponsivePropType,
} from "../../propTypes";
import { NessieThemeColors } from "../../theme";
import UnstyledButton from "../../../../components/buttons/UnstyledButton";
type CastIconProps = React.SVGProps<SVGSVGElement> &
  NessieComponentProps & {
    size?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
    color?: NessieThemeColors;
    onClick?: () => void;
    cursor?: React.CSSProperties["cursor"];
    display?: React.CSSProperties["display"];
    "data-test-name"?: string;
    "aria-label"?: string;
  };

let CastIcon: NessieFunctionComponent<CastIconProps> = ({
  size = "m",
  color = "shale",
  onClick,
  cursor,
  display = "inline-block",
  ["data-test-name"]: dataTestName,
  ["aria-label"]: ariaLabel,
  ...props
}) => {
  const sizeInPixels = SIZES[size];
  const ButtonOrSpan = onClick ? UnstyledButton : "span";
  return (
    <ButtonOrSpan
      aria-label={ariaLabel}
      data-test-name={dataTestName}
      onClick={onClick}
      sx={{
        fontSize: sizeInPixels,
        display,
        lineHeight: 0,
        color,
        cursor,
        position: "relative",
      }}
    >
      {
        <svg
          width="1em"
          height="1em"
          viewBox="0 0 24 24"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.873 7.431a1.5 1.5 0 11-2.222 2.016A10.467 10.467 0 0011.873 6C8.877 6 6.087 7.26 4.109 9.43A1.5 1.5 0 111.89 7.41 13.466 13.466 0 0111.873 3c3.858 0 7.458 1.63 10 4.431zM11.873 21a3 3 0 100-6 3 3 0 000 6zm5.868-6.46a1.5 1.5 0 00.457-2.071A7.494 7.494 0 0011.873 9a7.494 7.494 0 00-6.31 3.444 1.5 1.5 0 002.522 1.624A4.495 4.495 0 0111.872 12c1.557 0 2.975.795 3.797 2.083a1.5 1.5 0 002.072.457z"
          />
          <mask maskUnits="userSpaceOnUse" x={1} y={3} width={22} height={18}>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M21.873 7.431a1.5 1.5 0 11-2.222 2.016A10.467 10.467 0 0011.873 6C8.877 6 6.087 7.26 4.109 9.43A1.5 1.5 0 111.89 7.41 13.466 13.466 0 0111.873 3c3.858 0 7.458 1.63 10 4.431zM11.873 21a3 3 0 100-6 3 3 0 000 6zm5.868-6.46a1.5 1.5 0 00.457-2.071A7.494 7.494 0 0011.873 9a7.494 7.494 0 00-6.31 3.444 1.5 1.5 0 002.522 1.624A4.495 4.495 0 0111.872 12c1.557 0 2.975.795 3.797 2.083a1.5 1.5 0 002.072.457z"
            />
          </mask>
        </svg>
      }
    </ButtonOrSpan>
  );
};

const SIZES = {
  xs: "12px",
  s: "18px",
  m: "24px",
  l: "36px",
  xl: "48px",
  xxl: "56px",
};
CastIcon.nessiePropTypes = {
  color: colorNessieResponsivePropType,
  size: oneOfNessieResponsivePropType(["xs", "s", "m", "l", "xl", "xxl"]),
}; // ------------------------------------------
// ------------------------------------------
// DEV ONLY better prop checking

if (process.env.NODE_ENV === "development") {
  CastIcon = nessiePropCheckerWrapper(CastIcon);
}

export default CastIcon;
